export default __webpack_public_path__ + "static/media/subpics1.5a1225da.jpg";